// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"y1-z","dimensionLabel":"z1-z","styleChooserControlWrapper":"A1-z","styleChooserControl":"B1-z","disabled":"C1-z","giftCard":"D1-z","styleChooserText":"E1-z"};